import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavLang from "./components/NavLang";

import BlockBanner from "./blocks/BlockBanner";
import BlockCards from "./blocks/BlockCards";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockListTextImage from "./blocks/BlockListTextImage";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockSliderTermites from "./blocks/BlockSliderTermites";
import BlockStorytellingImage from "./blocks/BlockStorytellingImage";
import BlockTextCards from "./blocks/BlockTextCards";
import BlockVideosScroller from "./blocks/BlockVideosScroller";

import Halo from "./components/Halo";
import SectionOverlay from "./components/SectionOverlay";
import Tilt from "./components/Tilt";

import Share from "./components/Share";
import Typography from "./components/Typography";
import PopupUSA from "./components/PopupUSA";

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	PopupUSA.init();
	Header.init();
	NavsFull.init();
	NavLang.init();

	// Blocks
	BlockBanner.init();
	BlockCards.init();
	BlockCollapse.init();
	BlockGallerySlider.init();
	BlockListTextImage.init();
	BlockMap.init();
	BlockMovie.init();
	BlockSliderTermites.init();
	BlockStorytellingImage.init();
	BlockTextCards.init();
	BlockVideosScroller.init();

	Halo.init();
	SectionOverlay.init();
	Tilt.init();
	Typography.init();

	Share.init();
});
